// extracted by mini-css-extract-plugin
export default {"tip":"RecalculateModal_tip__WUnBV"};